import axios from "../../config/axiosConfig";
import { CREATE_PRODUCTION_REPACKING, GET_PRODUCTION_REPACKINGS, PRODUCTION_REPACKING_REQUEST, UPDATE_PRODUCTION_REPACKING, DELETE_PRODUCTION_REPACKING, PRODUCTION_REPACKING_FAILURE,
  GET_PRODUCTION_REPACKING_PAGE, PRODUCTION_REPACKING_REQUEST_SUCCESS
} from "../types";

export const getProductionsRepackingWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Quality',
      };
      return axios.get("/production-repacking/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_REPACKING_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
    }
  };
};

export const getProductionsRepacking = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
      if (include) {
        params = { ...params, include };
      }
      // if (!auth?.company?.Common_Company) {
      //   params = { ...params, companyId: auth.company?.id }
      // }
      return axios.get("/production-repacking/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_REPACKING_PAGE, payload: response.data?.data || [] });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getProductionRepackingById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      return axios.get(`/production-repacking/get/${id}`).then((response) => {
        dispatch({ type: PRODUCTION_REPACKING_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
    }
  };
};

export const getAllTwistOptionsInProductionRepacking = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
      };
      return axios.get(`/production-repacking/get-all-twist-options-in-production`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getAllGstLotDescCheckedByPackedByOptionsInProductionRepacking = (includeLotDesc) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        includeLotDesc: includeLotDesc
      };
      return axios.get(`/production-repacking/get-all-gst-lot-desc-checkedby-packedby-opt`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getValidatedIncrementedTakaNoProductionRepackingEntry = (otherparams) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(otherparams) {
        params = { ...params, ...otherparams };
      }
      const response = await axios.get("/production-repacking/get-next-taka-number", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const isTakaNoExitsInProductionRepacking = (otherparams) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(otherparams) {
        params = { ...params, ...otherparams };
      }
      const response = await axios.get("/production-repacking/is-taka-no-exist", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getProductionRePackings = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-repacking/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_REPACKINGS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createProductionRePacking = (production) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      return axios.post("/production-repacking/add", production,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PRODUCTION_REPACKING, payload: response.data });
        } else {
          dispatch({
            type: PRODUCTION_REPACKING_FAILURE,
            error: "Production create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateProductionRePacking = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      const { auth } = getState();
      return axios.put("/production-repacking/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PRODUCTION_REPACKING,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PRODUCTION_REPACKING_FAILURE,
            error: "Production code update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteProductionRePacking = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REPACKING_REQUEST });
      return axios.delete(`/production-repacking/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PRODUCTION_REPACKING, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date', 'Account_Id', 'Quality'].join(',');
          const searchCols = ['Vch_No', 'Book_Id', 'Date', 'Account_Id', 'Quality', 'totalWeight', 'totalMeter', 'totalTaka'].join(',');
          const { page, pageSize, searchStr, where,  } = getState()?.inventory?.production || {};
          dispatch(getProductionsRepackingWithPagination(page, pageSize, include, searchStr, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REPACKING_FAILURE, error: error.message });
      throw error;
    }
  };
};